/* eslint-disable react/style-prop-object */
import React from "react";
import {
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Avvvatars from "avvvatars-react";
import { resetUser } from "../features/user/userSlice";
import { AppDispatch, RootState } from "../store";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTranslation } from "react-i18next";

const HeaderUser = () => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user.user);

  if (!user?.fio?.length) {
    return null;
  }

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(resetUser());
    window.location.href = "/";
  };

  return (
    <ListItem sx={{ mx: 2, width: "auto" }}>
      <ListItemAvatar>
        <Avvvatars style="shape" shadow size={42} value={user.login} />
      </ListItemAvatar>
      <ListItemText primary={user.fio} secondary={user.login} />
      <IconButton
        onClick={handleLogout}
        title={t("common.logout")}
        sx={{ ml: 2 }}
      >
        <LogoutIcon color="action" />
      </IconButton>
    </ListItem>
  );
};

export default HeaderUser;
